import Box from '@mui/material/Box';
import { DataGrid, GridColDef } from '@mui/x-data-grid';

const columns: GridColDef<(typeof rows)[number]>[] = [
  { field: 'id', headerName: 'ID', width: 90 },
  {
    field: 'planName',
    headerName: 'Номер плана',
    width: 200,
    editable: true,
  },
  {
    field: 'frozenOrdersAmount',
    headerName: 'Количество замороженных заказов',
    width: 300,
    editable: true,
  },
  {
    field: 'requestedAmount',
    headerName: 'Запрашиваемая сумма',
    type: 'number',
    width: 200,
    editable: true,
  },
  {
    field: 'openAmount',
    headerName: 'Открытая сумма',
    description: 'Тут может быть подсказка.',
    sortable: false,
    width: 200,
    
  },
];

const rows = [
    {
      "id": 2456,
      "planName": "check",
      "active": true,
      "planBeginTs": "2024-03-03T21:00:00.000+00:00",
      "planEndTs": "2024-06-29T21:00:00.000+00:00",
      "planDate": "2024-05-30T09:29:13.203+00:00",
      "restrictionId": 1865,
      "username": "aonlmk\\fomenko_de2",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 100348,
      "requestedAmount": 653090,
      "openAmount": 295346,
      "experimental": null
    },
    {
      "id": 2455,
      "planName": "2024-05-30-mda1",
      "active": true,
      "planBeginTs": "2024-05-29T21:00:00.000+00:00",
      "planEndTs": "2024-06-29T21:00:00.000+00:00",
      "planDate": "2024-05-30T07:05:05.969+00:00",
      "restrictionId": 1864,
      "username": "aonlmk\\maynichev_da",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": null,
      "requestedAmount": null,
      "openAmount": null,
      "experimental": null
    },
    {
      "id": 2454,
      "planName": "2024-05-29-5",
      "active": true,
      "planBeginTs": "2024-05-28T21:00:00.000+00:00",
      "planEndTs": "2024-06-28T21:00:00.000+00:00",
      "planDate": "2024-05-29T16:04:17.517+00:00",
      "restrictionId": 1863,
      "username": "aonlmk\\eremin_ma",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 111165,
      "requestedAmount": 653090,
      "openAmount": 307707,
      "experimental": null
    },
    {
      "id": 2453,
      "planName": "2024-05-29-4",
      "active": true,
      "planBeginTs": "2024-05-28T21:00:00.000+00:00",
      "planEndTs": "2024-06-28T21:00:00.000+00:00",
      "planDate": "2024-05-29T15:06:06.282+00:00",
      "restrictionId": 1862,
      "username": "aonlmk\\eremin_ma",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 111837,
      "requestedAmount": 653090,
      "openAmount": 307808,
      "experimental": null
    },
    {
      "id": 2452,
      "planName": "2024-05-29-3",
      "active": true,
      "planBeginTs": "2024-05-28T21:00:00.000+00:00",
      "planEndTs": "2024-06-28T21:00:00.000+00:00",
      "planDate": "2024-05-29T15:05:50.282+00:00",
      "restrictionId": 1861,
      "username": "aonlmk\\eremin_ma",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 111837,
      "requestedAmount": 653090,
      "openAmount": 307776,
      "experimental": null
    },
    {
      "id": 2451,
      "planName": "2024-05-29-2",
      "active": true,
      "planBeginTs": "2024-05-28T21:00:00.000+00:00",
      "planEndTs": "2024-06-28T21:00:00.000+00:00",
      "planDate": "2024-05-29T15:05:05.185+00:00",
      "restrictionId": 1860,
      "username": "aonlmk\\eremin_ma",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 111837,
      "requestedAmount": 653090,
      "openAmount": 307776,
      "experimental": null
    },
    {
      "id": 2450,
      "planName": "2024-05-29-1",
      "active": true,
      "planBeginTs": "2024-05-28T21:00:00.000+00:00",
      "planEndTs": "2024-06-28T21:00:00.000+00:00",
      "planDate": "2024-05-29T09:37:49.487+00:00",
      "restrictionId": 1859,
      "username": "aonlmk\\eremin_ma",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 109579,
      "requestedAmount": 651290,
      "openAmount": 305322,
      "experimental": null
    },
    {
      "id": 2449,
      "planName": "2024-05-29-mda1",
      "active": true,
      "planBeginTs": "2024-05-28T21:00:00.000+00:00",
      "planEndTs": "2024-06-28T21:00:00.000+00:00",
      "planDate": "2024-05-29T07:04:27.730+00:00",
      "restrictionId": 1858,
      "username": "aonlmk\\maynichev_da",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": null,
      "requestedAmount": null,
      "openAmount": null,
      "experimental": null
    },
    {
      "id": 2448,
      "planName": "2024-05-28-11",
      "active": true,
      "planBeginTs": "2024-05-27T21:00:00.000+00:00",
      "planEndTs": "2024-06-27T21:00:00.000+00:00",
      "planDate": "2024-05-28T14:44:17.777+00:00",
      "restrictionId": 1857,
      "username": "aonlmk\\eremin_ma",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 96702,
      "requestedAmount": 648250,
      "openAmount": 305990,
      "experimental": null
    },
    {
      "id": 2447,
      "planName": "2024-05-28-10",
      "active": true,
      "planBeginTs": "2024-05-27T21:00:00.000+00:00",
      "planEndTs": "2024-06-27T21:00:00.000+00:00",
      "planDate": "2024-05-28T14:43:49.648+00:00",
      "restrictionId": 1856,
      "username": "aonlmk\\eremin_ma",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 96702,
      "requestedAmount": 648250,
      "openAmount": 305990,
      "experimental": null
    },
    {
      "id": 2446,
      "planName": "2024-05-28-9",
      "active": true,
      "planBeginTs": "2024-05-27T21:00:00.000+00:00",
      "planEndTs": "2024-06-27T21:00:00.000+00:00",
      "planDate": "2024-05-28T14:43:28.674+00:00",
      "restrictionId": 1855,
      "username": "aonlmk\\eremin_ma",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 96702,
      "requestedAmount": 648250,
      "openAmount": 305990,
      "experimental": null
    },
    {
      "id": 2445,
      "planName": "2024-05-28-8",
      "active": true,
      "planBeginTs": "2024-05-27T21:00:00.000+00:00",
      "planEndTs": "2024-06-27T21:00:00.000+00:00",
      "planDate": "2024-05-28T14:43:07.268+00:00",
      "restrictionId": 1854,
      "username": "aonlmk\\eremin_ma",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 96702,
      "requestedAmount": 648250,
      "openAmount": 305990,
      "experimental": null
    },
    {
      "id": 2444,
      "planName": "2024-05-28-7",
      "active": true,
      "planBeginTs": "2024-05-27T21:00:00.000+00:00",
      "planEndTs": "2024-06-27T21:00:00.000+00:00",
      "planDate": "2024-05-28T13:56:25.423+00:00",
      "restrictionId": 1853,
      "username": "aonlmk\\eremin_ma",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 96758,
      "requestedAmount": 648250,
      "openAmount": 303850,
      "experimental": null
    },
    {
      "id": 2443,
      "planName": "test_mps",
      "active": true,
      "planBeginTs": "2024-03-03T21:00:00.000+00:00",
      "planEndTs": "2024-06-27T21:00:00.000+00:00",
      "planDate": "2024-05-28T12:48:27.630+00:00",
      "restrictionId": 1852,
      "username": "aonlmk\\fomenko_de2",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 98001,
      "requestedAmount": 648250,
      "openAmount": 305713,
      "experimental": null
    },
    {
      "id": 2442,
      "planName": "2024-05-28-6",
      "active": true,
      "planBeginTs": "2024-05-27T21:00:00.000+00:00",
      "planEndTs": "2024-06-27T21:00:00.000+00:00",
      "planDate": "2024-05-28T12:39:11.351+00:00",
      "restrictionId": 1852,
      "username": "aonlmk\\eremin_ma",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 98351,
      "requestedAmount": 648250,
      "openAmount": 305713,
      "experimental": null
    },
    {
      "id": 2441,
      "planName": "2024-05-27-8",
      "active": true,
      "planBeginTs": "2024-03-03T21:00:00.000+00:00",
      "planEndTs": "2024-06-27T21:00:00.000+00:00",
      "planDate": "2024-05-28T12:10:01.413+00:00",
      "restrictionId": 1845,
      "username": "aonlmk\\fomenko_de2",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 98645,
      "requestedAmount": 648250,
      "openAmount": 305713,
      "experimental": null
    },
    {
      "id": 2440,
      "planName": "2024-05-28-4",
      "active": true,
      "planBeginTs": "2024-05-27T21:00:00.000+00:00",
      "planEndTs": "2024-06-27T21:00:00.000+00:00",
      "planDate": "2024-05-28T06:56:02.280+00:00",
      "restrictionId": 1851,
      "username": "aonlmk\\eremin_ma",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 68831,
      "requestedAmount": 695040,
      "openAmount": 334948,
      "experimental": null
    },
    {
      "id": 2439,
      "planName": "2024-05-28-3",
      "active": true,
      "planBeginTs": "2024-05-27T21:00:00.000+00:00",
      "planEndTs": "2024-06-27T21:00:00.000+00:00",
      "planDate": "2024-05-28T06:55:46.926+00:00",
      "restrictionId": 1850,
      "username": "aonlmk\\eremin_ma",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 68831,
      "requestedAmount": 695040,
      "openAmount": 334948,
      "experimental": null
    },
    {
      "id": 2438,
      "planName": "2024-05-28-mda1",
      "active": true,
      "planBeginTs": "2024-05-27T21:00:00.000+00:00",
      "planEndTs": "2024-06-27T21:00:00.000+00:00",
      "planDate": "2024-05-28T06:52:01.868+00:00",
      "restrictionId": 1849,
      "username": "aonlmk\\maynichev_da",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": null,
      "requestedAmount": null,
      "openAmount": null,
      "experimental": null
    },
    {
      "id": 2437,
      "planName": "2024-05-28-2",
      "active": true,
      "planBeginTs": "2024-05-27T21:00:00.000+00:00",
      "planEndTs": "2024-06-27T21:00:00.000+00:00",
      "planDate": "2024-05-28T06:18:38.608+00:00",
      "restrictionId": 1848,
      "username": "aonlmk\\eremin_ma",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 69115,
      "requestedAmount": 695040,
      "openAmount": 334948,
      "experimental": null
    },
    {
      "id": 2496,
      "planName": "2024-06-04-8",
      "active": true,
      "planBeginTs": "2024-03-03T21:00:00.000+00:00",
      "planEndTs": "2024-07-03T21:00:00.000+00:00",
      "planDate": "2024-06-04T11:41:28.871+00:00",
      "restrictionId": 1911,
      "username": "aonlmk\\fomenko_de2",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 85805,
      "requestedAmount": 593840,
      "openAmount": 311687,
      "experimental": null
    },
    {
      "id": 2495,
      "planName": "2024-06-03-6",
      "active": true,
      "planBeginTs": "2024-03-03T21:00:00.000+00:00",
      "planEndTs": "2024-07-03T21:00:00.000+00:00",
      "planDate": "2024-06-04T11:14:57.534+00:00",
      "restrictionId": 1906,
      "username": "aonlmk\\fomenko_de2",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 86423,
      "requestedAmount": 593840,
      "openAmount": 311687,
      "experimental": null
    },
    {
      "id": 2494,
      "planName": "2024-06-04-4",
      "active": true,
      "planBeginTs": "2024-03-03T21:00:00.000+00:00",
      "planEndTs": "2024-07-03T21:00:00.000+00:00",
      "planDate": "2024-06-04T11:03:55.947+00:00",
      "restrictionId": 1911,
      "username": "aonlmk\\fomenko_de2",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 86423,
      "requestedAmount": 593840,
      "openAmount": 301377,
      "experimental": null
    },
    {
      "id": 2493,
      "planName": "2024-06-04-6",
      "active": true,
      "planBeginTs": "2024-06-03T21:00:00.000+00:00",
      "planEndTs": "2024-07-03T21:00:00.000+00:00",
      "planDate": "2024-06-04T09:04:46.806+00:00",
      "restrictionId": 1914,
      "username": "aonlmk\\eremin_ma",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 97413,
      "requestedAmount": 593840,
      "openAmount": 299353,
      "experimental": null
    },
    {
      "id": 2492,
      "planName": "2024-06-04-5",
      "active": true,
      "planBeginTs": "2024-06-03T21:00:00.000+00:00",
      "planEndTs": "2024-07-03T21:00:00.000+00:00",
      "planDate": "2024-06-04T09:04:18.146+00:00",
      "restrictionId": 1913,
      "username": "aonlmk\\eremin_ma",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 97413,
      "requestedAmount": 593840,
      "openAmount": 299353,
      "experimental": null
    },
    {
      "id": 2491,
      "planName": "2024-06-04-4",
      "active": true,
      "planBeginTs": "2024-06-03T21:00:00.000+00:00",
      "planEndTs": "2024-07-03T21:00:00.000+00:00",
      "planDate": "2024-06-04T09:03:53.086+00:00",
      "restrictionId": 1912,
      "username": "aonlmk\\eremin_ma",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 97413,
      "requestedAmount": 593840,
      "openAmount": 299353,
      "experimental": null
    },
    {
      "id": 2490,
      "planName": "2024-06-04-3",
      "active": true,
      "planBeginTs": "2024-06-03T21:00:00.000+00:00",
      "planEndTs": "2024-07-03T21:00:00.000+00:00",
      "planDate": "2024-06-04T08:29:01.009+00:00",
      "restrictionId": 1911,
      "username": "aonlmk\\eremin_ma",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 98091,
      "requestedAmount": 593840,
      "openAmount": 299354,
      "experimental": null
    },
    {
      "id": 2489,
      "planName": "2024-06-04-2",
      "active": true,
      "planBeginTs": "2024-06-03T21:00:00.000+00:00",
      "planEndTs": "2024-07-03T21:00:00.000+00:00",
      "planDate": "2024-06-04T08:28:28.603+00:00",
      "restrictionId": 1910,
      "username": "aonlmk\\eremin_ma",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 98091,
      "requestedAmount": 593840,
      "openAmount": 299354,
      "experimental": null
    },
    {
      "id": 2488,
      "planName": "2024-06-04-1",
      "active": true,
      "planBeginTs": "2024-06-03T21:00:00.000+00:00",
      "planEndTs": "2024-07-03T21:00:00.000+00:00",
      "planDate": "2024-06-04T08:27:56.106+00:00",
      "restrictionId": 1909,
      "username": "aonlmk\\eremin_ma",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 98091,
      "requestedAmount": 593840,
      "openAmount": 299354,
      "experimental": null
    },
    {
      "id": 2487,
      "planName": "2024-06-04-mda1",
      "active": true,
      "planBeginTs": "2024-06-03T21:00:00.000+00:00",
      "planEndTs": "2024-07-03T21:00:00.000+00:00",
      "planDate": "2024-06-04T07:00:43.333+00:00",
      "restrictionId": 1908,
      "username": "aonlmk\\maynichev_da",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": null,
      "requestedAmount": null,
      "openAmount": null,
      "experimental": null
    },
    {
      "id": 2486,
      "planName": "2024-06-03-4",
      "active": true,
      "planBeginTs": "2024-06-02T21:00:00.000+00:00",
      "planEndTs": "2024-07-02T21:00:00.000+00:00",
      "planDate": "2024-06-03T15:14:31.037+00:00",
      "restrictionId": 1907,
      "username": "aonlmk\\eremin_ma",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 93798,
      "requestedAmount": 610840,
      "openAmount": 320412,
      "experimental": null
    },
    {
      "id": 2485,
      "planName": "2024-06-03-3",
      "active": true,
      "planBeginTs": "2024-06-02T21:00:00.000+00:00",
      "planEndTs": "2024-07-02T21:00:00.000+00:00",
      "planDate": "2024-06-03T15:13:48.504+00:00",
      "restrictionId": 1906,
      "username": "aonlmk\\eremin_ma",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 93798,
      "requestedAmount": 610840,
      "openAmount": 320412,
      "experimental": null
    },
    {
      "id": 2484,
      "planName": "2024-06-03-2",
      "active": true,
      "planBeginTs": "2024-06-02T21:00:00.000+00:00",
      "planEndTs": "2024-07-02T21:00:00.000+00:00",
      "planDate": "2024-06-03T15:13:15.507+00:00",
      "restrictionId": 1905,
      "username": "aonlmk\\eremin_ma",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 93798,
      "requestedAmount": 610840,
      "openAmount": 320412,
      "experimental": null
    },
    {
      "id": 2483,
      "planName": "2024-06-03-mda1",
      "active": true,
      "planBeginTs": "2024-06-02T21:00:00.000+00:00",
      "planEndTs": "2024-07-02T21:00:00.000+00:00",
      "planDate": "2024-06-03T13:23:01.206+00:00",
      "restrictionId": 1904,
      "username": "aonlmk\\maynichev_da",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": null,
      "requestedAmount": null,
      "openAmount": null,
      "experimental": null
    },
    {
      "id": 2482,
      "planName": "2024-06-03-1",
      "active": true,
      "planBeginTs": "2024-06-02T21:00:00.000+00:00",
      "planEndTs": "2024-07-02T21:00:00.000+00:00",
      "planDate": "2024-06-03T07:57:44.882+00:00",
      "restrictionId": 1903,
      "username": "aonlmk\\eremin_ma",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 78335,
      "requestedAmount": 610840,
      "openAmount": 340462,
      "experimental": null
    },
    {
      "id": 2481,
      "planName": "2024-06-02-9",
      "active": true,
      "planBeginTs": "2024-06-01T21:00:00.000+00:00",
      "planEndTs": "2024-07-01T21:00:00.000+00:00",
      "planDate": "2024-06-02T13:05:25.682+00:00",
      "restrictionId": 1902,
      "username": "aonlmk\\eremin_ma",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 99953,
      "requestedAmount": 628990,
      "openAmount": 339675,
      "experimental": null
    },
    {
      "id": 2480,
      "planName": "2024-06-02-8",
      "active": true,
      "planBeginTs": "2024-06-01T21:00:00.000+00:00",
      "planEndTs": "2024-07-01T21:00:00.000+00:00",
      "planDate": "2024-06-02T13:04:47.450+00:00",
      "restrictionId": 1901,
      "username": "aonlmk\\eremin_ma",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 99953,
      "requestedAmount": 628990,
      "openAmount": 339994,
      "experimental": null
    },
    {
      "id": 2479,
      "planName": "2024-06-02-7",
      "active": true,
      "planBeginTs": "2024-06-01T21:00:00.000+00:00",
      "planEndTs": "2024-06-29T21:00:00.000+00:00",
      "planDate": "2024-06-02T12:58:26.412+00:00",
      "restrictionId": 1900,
      "username": "aonlmk\\eremin_ma",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": null,
      "requestedAmount": null,
      "openAmount": null,
      "experimental": null
    },
    {
      "id": 2478,
      "planName": "2024-06-02-6",
      "active": true,
      "planBeginTs": "2024-06-01T21:00:00.000+00:00",
      "planEndTs": "2024-06-29T21:00:00.000+00:00",
      "planDate": "2024-06-02T12:55:52.359+00:00",
      "restrictionId": 1899,
      "username": "aonlmk\\eremin_ma",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 100285,
      "requestedAmount": 628990,
      "openAmount": 339932,
      "experimental": null
    },
    {
      "id": 2477,
      "planName": "2024-06-02-4",
      "active": true,
      "planBeginTs": "2024-06-01T21:00:00.000+00:00",
      "planEndTs": "2024-07-01T21:00:00.000+00:00",
      "planDate": "2024-06-02T12:52:28.052+00:00",
      "restrictionId": 1898,
      "username": "aonlmk\\eremin_ma",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": null,
      "requestedAmount": null,
      "openAmount": null,
      "experimental": null
    },
    {
      "id": 2516,
      "planName": "2024-06-06-2",
      "active": true,
      "planBeginTs": "2024-06-05T21:00:00.000+00:00",
      "planEndTs": "2024-07-05T21:00:00.000+00:00",
      "planDate": "2024-06-06T07:08:15.335+00:00",
      "restrictionId": 1932,
      "username": "qusolve_user10",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 78063,
      "requestedAmount": 592040,
      "openAmount": 288325,
      "experimental": null
    },
    {
      "id": 2515,
      "planName": "2024-06-061",
      "active": true,
      "planBeginTs": "2024-06-05T21:00:00.000+00:00",
      "planEndTs": "2024-07-05T21:00:00.000+00:00",
      "planDate": "2024-06-06T06:11:00.927+00:00",
      "restrictionId": 1931,
      "username": "qusolve_user10",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 78063,
      "requestedAmount": 592040,
      "openAmount": 288325,
      "experimental": null
    },
    {
      "id": 2514,
      "planName": "2024-06-05-7",
      "active": true,
      "planBeginTs": "2024-06-04T21:00:00.000+00:00",
      "planEndTs": "2024-07-04T21:00:00.000+00:00",
      "planDate": "2024-06-05T17:49:58.264+00:00",
      "restrictionId": 1930,
      "username": "aonlmk\\eremin_ma",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": null,
      "requestedAmount": null,
      "openAmount": null,
      "experimental": null
    },
    {
      "id": 2513,
      "planName": "2024-06-05-6",
      "active": true,
      "planBeginTs": "2024-06-04T21:00:00.000+00:00",
      "planEndTs": "2024-07-04T21:00:00.000+00:00",
      "planDate": "2024-06-05T17:37:38.613+00:00",
      "restrictionId": 1929,
      "username": "aonlmk\\eremin_ma",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 81908,
      "requestedAmount": 592040,
      "openAmount": 288325,
      "experimental": null
    },
    {
      "id": 2512,
      "planName": "2024-06-05-5",
      "active": true,
      "planBeginTs": "2024-06-04T21:00:00.000+00:00",
      "planEndTs": "2024-07-04T21:00:00.000+00:00",
      "planDate": "2024-06-05T17:37:25.196+00:00",
      "restrictionId": 1928,
      "username": "aonlmk\\eremin_ma",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 81908,
      "requestedAmount": 592040,
      "openAmount": 288325,
      "experimental": null
    },
    {
      "id": 2511,
      "planName": "2024-06-05-4",
      "active": true,
      "planBeginTs": "2024-06-04T21:00:00.000+00:00",
      "planEndTs": "2024-07-04T21:00:00.000+00:00",
      "planDate": "2024-06-05T17:32:25.563+00:00",
      "restrictionId": 1927,
      "username": "aonlmk\\eremin_ma",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": null,
      "requestedAmount": null,
      "openAmount": null,
      "experimental": null
    },
    {
      "id": 2510,
      "planName": "2024-06-05-3",
      "active": true,
      "planBeginTs": "2024-06-04T21:00:00.000+00:00",
      "planEndTs": "2024-07-04T21:00:00.000+00:00",
      "planDate": "2024-06-05T17:14:28.714+00:00",
      "restrictionId": 1926,
      "username": "aonlmk\\eremin_ma",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": null,
      "requestedAmount": null,
      "openAmount": null,
      "experimental": null
    },
    {
      "id": 2509,
      "planName": "2024-06-05-2",
      "active": true,
      "planBeginTs": "2024-06-04T21:00:00.000+00:00",
      "planEndTs": "2024-07-04T21:00:00.000+00:00",
      "planDate": "2024-06-05T14:43:56.353+00:00",
      "restrictionId": 1925,
      "username": "aonlmk\\eremin_ma",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 84566,
      "requestedAmount": 592040,
      "openAmount": 288152,
      "experimental": null
    },
    {
      "id": 2508,
      "planName": "2024-06-05-1",
      "active": true,
      "planBeginTs": "2024-06-04T21:00:00.000+00:00",
      "planEndTs": "2024-07-04T21:00:00.000+00:00",
      "planDate": "2024-06-05T14:37:06.449+00:00",
      "restrictionId": 1924,
      "username": "aonlmk\\eremin_ma",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": null,
      "requestedAmount": null,
      "openAmount": null,
      "experimental": null
    },
    {
      "id": 2507,
      "planName": "2024-06-05-mda1",
      "active": true,
      "planBeginTs": "2024-06-04T21:00:00.000+00:00",
      "planEndTs": "2024-07-04T21:00:00.000+00:00",
      "planDate": "2024-06-05T06:11:32.911+00:00",
      "restrictionId": 1923,
      "username": "aonlmk\\maynichev_da",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": null,
      "requestedAmount": null,
      "openAmount": null,
      "experimental": null
    },
    {
      "id": 2506,
      "planName": "2024-06-04-17",
      "active": true,
      "planBeginTs": "2024-06-03T21:00:00.000+00:00",
      "planEndTs": "2024-07-03T21:00:00.000+00:00",
      "planDate": "2024-06-04T15:19:24.681+00:00",
      "restrictionId": 1922,
      "username": "aonlmk\\eremin_ma",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 80936,
      "requestedAmount": 593840,
      "openAmount": 311970,
      "experimental": null
    },
    {
      "id": 2505,
      "planName": "2024-06-04-16",
      "active": true,
      "planBeginTs": "2024-06-03T21:00:00.000+00:00",
      "planEndTs": "2024-07-03T21:00:00.000+00:00",
      "planDate": "2024-06-04T15:19:02.412+00:00",
      "restrictionId": 1921,
      "username": "aonlmk\\eremin_ma",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 80936,
      "requestedAmount": 593840,
      "openAmount": 311970,
      "experimental": null
    },
    {
      "id": 2504,
      "planName": "2024-06-04-15",
      "active": true,
      "planBeginTs": "2024-06-03T21:00:00.000+00:00",
      "planEndTs": "2024-07-03T21:00:00.000+00:00",
      "planDate": "2024-06-04T14:36:39.235+00:00",
      "restrictionId": 1920,
      "username": "aonlmk\\eremin_ma",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 81929,
      "requestedAmount": 593840,
      "openAmount": 312026,
      "experimental": null
    },
    {
      "id": 2503,
      "planName": "2024-06-04-14",
      "active": true,
      "planBeginTs": "2024-06-03T21:00:00.000+00:00",
      "planEndTs": "2024-07-03T21:00:00.000+00:00",
      "planDate": "2024-06-04T14:33:24.863+00:00",
      "restrictionId": 1919,
      "username": "aonlmk\\eremin_ma",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 81929,
      "requestedAmount": 593840,
      "openAmount": 312026,
      "experimental": null
    },
    {
      "id": 2502,
      "planName": "2024-06-04-11",
      "active": true,
      "planBeginTs": "2024-06-03T21:00:00.000+00:00",
      "planEndTs": "2024-07-03T21:00:00.000+00:00",
      "planDate": "2024-06-04T11:58:16.949+00:00",
      "restrictionId": 1917,
      "username": "aonlmk\\fomenko_de2",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 85483,
      "requestedAmount": 593840,
      "openAmount": 311687,
      "experimental": null
    },
    {
      "id": 2501,
      "planName": "2024-06-04-1rrrrrr",
      "active": true,
      "planBeginTs": "2024-06-03T21:00:00.000+00:00",
      "planEndTs": "2024-07-03T21:00:00.000+00:00",
      "planDate": "2024-06-04T11:57:57.439+00:00",
      "restrictionId": 1918,
      "username": "aonlmk\\shirokov_nb",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 85483,
      "requestedAmount": 593840,
      "openAmount": 311687,
      "experimental": null
    },
    {
      "id": 2500,
      "planName": "2024-06-04-10",
      "active": true,
      "planBeginTs": "2024-06-03T21:00:00.000+00:00",
      "planEndTs": "2024-07-03T21:00:00.000+00:00",
      "planDate": "2024-06-04T11:56:52.618+00:00",
      "restrictionId": 1918,
      "username": "aonlmk\\eremin_ma",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 85483,
      "requestedAmount": 593840,
      "openAmount": 311687,
      "experimental": null
    },
    {
      "id": 2499,
      "planName": "2024-06-04-10",
      "active": true,
      "planBeginTs": "2024-03-03T21:00:00.000+00:00",
      "planEndTs": "2024-07-03T21:00:00.000+00:00",
      "planDate": "2024-06-04T11:55:25.807+00:00",
      "restrictionId": 1917,
      "username": "aonlmk\\fomenko_de2",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 85483,
      "requestedAmount": 593840,
      "openAmount": 311687,
      "experimental": null
    },
    {
      "id": 2498,
      "planName": "2024-06-04-9",
      "active": true,
      "planBeginTs": "2024-03-03T21:00:00.000+00:00",
      "planEndTs": "2024-07-03T21:00:00.000+00:00",
      "planDate": "2024-06-04T11:52:38.720+00:00",
      "restrictionId": 1916,
      "username": "aonlmk\\fomenko_de2",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 85483,
      "requestedAmount": 593840,
      "openAmount": 311687,
      "experimental": null
    },
    {
      "id": 2497,
      "planName": "2024-06-04-7",
      "active": true,
      "planBeginTs": "2024-06-03T21:00:00.000+00:00",
      "planEndTs": "2024-07-03T21:00:00.000+00:00",
      "planDate": "2024-06-04T11:46:03.388+00:00",
      "restrictionId": 1915,
      "username": "aonlmk\\eremin_ma",
      "parentPlanId": null,
      "planType": null,
      "scheduled": false,
      "frozenOrdersAmount": 85483,
      "requestedAmount": 593840,
      "openAmount": 311687,
      "experimental": null
    }
  ];

export default function DataGridDemo() {
  return (
    <Box sx={{ height: 700, width: '50%', boxShadow: 2,
      border: 2,
      borderColor: 'primary.light',
      '& .MuiDataGrid-cell:hover': {
        color: 'primary.main',
      },
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      margin: 'auto', }}>
      <DataGrid
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 20,
            },
          },
        }}
        pageSizeOptions={[20]}
        checkboxSelection
        disableRowSelectionOnClick
      />
    </Box>
  );
}